module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_Quadra.ec7e77c4.jpg";